import { render, staticRenderFns } from "./QuestionarioHospitalDia.vue?vue&type=template&id=39d1da0a&scoped=true"
import script from "./QuestionarioHospitalDia.vue?vue&type=script&lang=js"
export * from "./QuestionarioHospitalDia.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioHospitalDia.vue?vue&type=style&index=0&id=39d1da0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d1da0a",
  null
  
)

export default component.exports